import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useProductsContext } from '../../context/products_context';
import { IoMdClose } from 'react-icons/io';
import Loading from '../Loading';
import { useCartContext } from '../../context/cart_context';
const CouponCodesPopup = ({
  setOpenCouponPopup,
  setSelectedCoupon,
  selectedCoupon,
}) => {
  const [metalPrices, setMetalPrices] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { closePricePopup } = useProductsContext();
  const [showGold, setshowGold] = useState(true);
  const [couponCodes, setCouponCodes] = useState([]);
  const {cart}=useCartContext()
  const getAllPromocodes = async () => {
    setIsLoading(true);
    let res = await axios.get(
      `${process.env.REACT_APP_BACKEND_HOST}/api/promocodes`
    );
   const cartCategories = cart.map((item) => item.category);
   const date=new Date()

   let filteredCodes = res.data.data.filter((code) =>
     cartCategories.some((cat) => code.categories.includes(cat))
   );
   let unexpiredcodes=filteredCodes?.filter((e)=>new Date(e?.expiryDate)>date)
   setCouponCodes(unexpiredcodes);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllPromocodes();
  }, []);
  const handleSubmit = () => {
    setCouponCodes();
    setOpenCouponPopup(false);
  };

  return (
    <div className='fixed inset-0 bg-[rgba(0,0,0,0.5)] bg-opacity-40 flex items-center justify-center z-50'>
      <div className='bg-white w-full max-w-md rounded-xl shadow-lg relative'>
        {!isLoading && (
          <>
            <div className='w-full flex justify-between items-center mb-3 bg-[#010535] text-white p-4 rounded-t-xl'>
              <h1 className=''>Coupon codes</h1>
              <div
                className='flex justify-end  rounded-md items-end'
                onClick={() => setOpenCouponPopup(false)}
              >
                <IoMdClose className='w-6 h-6' />
              </div>
            </div>

            {/* Buttons */}

            {couponCodes && couponCodes.length > 0 && (
              <div className='flex flex-col gap-3 py-3 px-6'>
                <div className='flex flex-col gap-3'>
                  <h1 className='text-[#D3A143]'></h1>
                  <ul className='flex flex-col gap-4'>
                    {couponCodes.map((e) => (
                      <li
                        key={e.code}
                        className={`border rounded-lg p-4 cursor-pointer transition ${
                          selectedCoupon?.code === e.code
                            ? 'border-[#D3A143] bg-[#FFF7E6]'
                            : 'border-gray-200'
                        }`}
                        onClick={() => setSelectedCoupon(e)}
                      >
                        <div className='flex items-start gap-5'>
                          <input
                            type='checkbox'
                            checked={selectedCoupon?.code === e.code}
                            onChange={() =>
                              selectedCoupon?.code === e.code
                                ? setSelectedCoupon(null)
                                : setSelectedCoupon(e)
                            }
                            className='mt-1 accent-[#D3A143] text-white'
                          />

                          <div className='flex flex-col gap-3'>
                            <span className='text-xs p-2 text-[#D3A143] font-medium border border-dashed border-[#D3A143]'>
                              Code: {e.code}
                            </span>
                            <h2 className='font-semibold text-black'>
                              Save up to {e.maximumDiscount} percentage
                            </h2>
                            <p className='text-sm text-gray-600'>
                              {e.description}
                            </p>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <div className='flex justify-center items-center'>
                    <button
                      onClick={handleSubmit}
                      className='bg-[#D3A143] rounded-md text-white p-2'
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            )}
            {couponCodes.length <= 0 &&<div className='p-6 flex justify-center items-center w-full'>No coupons found</div>}
          </>
        )}
        {isLoading && <Loading />}
      </div>
    </div>
  );
};
export default CouponCodesPopup;
